import { render } from "./MbBeforePurchaseCaution.vue?vue&type=template&id=51b55076&scoped=true"
import script from "./MbBeforePurchaseCaution.vue?vue&type=script&lang=js"
export * from "./MbBeforePurchaseCaution.vue?vue&type=script&lang=js"

import "./MbBeforePurchaseCaution.vue?vue&type=style&index=0&id=51b55076&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51b55076"

export default script